import api from './api';

const maintenanceProviderMasterService = {
  // Get all maintenance providers
  getAllProviders: async (params = {}) => {
    try {
      const response = await api.get('/maintenance-provider-master', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching maintenance providers:', error);
      throw error;
    }
  },

  // Get maintenance provider by ID
  getProviderById: async (id) => {
    try {
      const response = await api.get(`/maintenance-provider-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching maintenance provider:', error);
      throw error;
    }
  },

  // Create maintenance provider
  createProvider: async (data) => {
    try {
      const response = await api.post('/maintenance-provider-master', data);
      return response.data;
    } catch (error) {
      console.error('Error creating maintenance provider:', error);
      throw error;
    }
  },

  // Update maintenance provider
  updateProvider: async (id, data) => {
    try {
      const response = await api.put(`/maintenance-provider-master/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating maintenance provider:', error);
      throw error;
    }
  },

  // Delete maintenance provider
  deleteProvider: async (id) => {
    try {
      const response = await api.delete(`/maintenance-provider-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting maintenance provider:', error);
      throw error;
    }
  },

  // Get maintenance provider statistics
  getProviderStats: async () => {
    try {
      const response = await api.get('/maintenance-provider-master/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching maintenance provider statistics:', error);
      throw error;
    }
  },

  // Get next provider code
  getNextProviderCode: async () => {
    try {
      const response = await api.get('/maintenance-provider-master/next-code');
      return response.data;
    } catch (error) {
      console.error('Error fetching next provider code:', error);
      throw error;
    }
  }
};

export default maintenanceProviderMasterService;
